const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"006c92e5533b677307d07e4583468c704e79230f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["shika-rijikai@75d0cb1f2da9"]={id:"006c92e5533b677307d07e4583468c704e79230f"};
      